<template>
  <PointNotificationPanelSmall
    type="thanks"
    :url="url"
    class="p-the-a01-point-notification-panel-thanks"
  >
    <template #icon>
      <IconNotificationThanks />
    </template>
    <template #title><span data-translate-skip>{{ thanksPointName }}</span>が<br />届きました！</template>
    <template #detail>
      <div class="p-the-a01-point-notification-panel-thanks__detail">
        <IconUserImage
          :size="iconSize"
          class="p-the-a01-point-notification-panel-thanks__detail__icon"
        >
          <img
            v-if="giver.user_image"
            :src="giver.user_image"
            alt
          />
        </IconUserImage>
        <div>
          <p class="p-the-a01-point-notification-panel-thanks__detail__text">
            ポイント数：
            <span class="u-text-weight--bold" data-translate-skip>
              {{ addComma(point) }} {{ unit }}
            </span>
          </p>
          <p class="p-the-a01-point-notification-panel-thanks__detail__text">
            送り主：<span class="u-text-weight--bold" data-translate-skip>{{
              giver.id == 0 ? "－" : giver.user_name
            }}</span>
          </p>
        </div>
      </div>
    </template>
  </PointNotificationPanelSmall>
</template>

<script lang="ts">
import { mapState } from "vuex";
import PointNotificationPanelSmall from "@/general/components/molecules/PointNotificationPanelSmall.vue";
import CONST_DATA from "@/general/mixins/const/constData";
import IconNotificationThanks from "@/common/components/icons/IconNotificationThanks.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

@Options({
  props: {
    giver: { type: Object, required: true },
    point: { type: Number, required: true },
    url: { type: String, required: true }
  },
  components: {
    PointNotificationPanelSmall,
    IconNotificationThanks,
    IconUserImage
  }
})
export default class A01PointNotificationPanelThanks extends Vue {
  giver!: any;
  point!: number;
  url!: string;

  isSpScreenWidth = commons.isSpScreenWidth;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  get iconSize() {
    const iconSize = {
      sp: 32,
      pc: 32
    };
    const index = this.isSpScreenWidth ? "sp" : "pc";
    return iconSize[index];
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }
  
  addComma(value: any) {
    const number = Number(value);
    if (Number.isNaN(number)) {
      return value;
    }
    return number.toLocaleString();
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-point-notification-panel-thanks {
  background-color: #f6bebe;

  &__detail {
    display: flex;

    &__icon {
      margin-right: rem(8);
    }

    &__text {
      @include text__body--xs;
      color: $common-white;
    }
  }
}
</style>
